<template>
  <div>
    <p>
      The pointing loss computation depends on the antenna radiation pattern
      (how the gain varies with roll-off), and thus on the antenna type. In
      space<strong>studio</strong>, the antennas are modelled as parabolic ones,
      where the directivity is represented by a profile given by
      <katex-element expression="\sin{\theta}^2 / \theta^2" />, where
      <katex-element expression="\theta" /> is the angle from the boresight
      direction in radians.
    </p>

    <h3>Parabolic antenna profile description</h3>
    <p>
      Let <katex-element expression="R_P(x) = \sin{x}^2 / x^2 " /> be the
      desired shape of the profile. In order to have a roll-off value of a
      factor of 0.5 at
      <katex-element expression="\theta = \mathrm{beamwidth}/2 " />, let's
      introduce the transformed angle <katex-element expression="\delta" />:
    </p>
    <p>
      <katex-element
        expression="\delta = \theta * \frac{\tau}{\mathrm{beamwidth}/2} "
      />
    </p>
    <p>
      where <katex-element expression="\tau \approx 1.3916" /> is such that
      <katex-element expression="R_P(\tau) = 0.5" />.
    </p>
    <p>
      The roll-off factor <katex-element expression="F" /> will then be given
      by:
    </p>
    <p>
      <katex-element
        expression="F(\theta) = R_P(\delta) = R_P(\theta * \frac{\tau}{\mathrm{beamwidth}/2} )"
      />
    </p>

    <p>
      For a pointing precision <katex-element expression="\theta" />, the
      pointing loss <katex-element expression="L_{P}" /> is given (in
      <katex-element expression="dB" />) by:
    </p>
    <p>
      <katex-element expression="L_{P} = -10 \log{F(\theta)}" />
    </p>
  </div>
</template>

<script>
export default {
  name: 'tooltipEquationPointingLoss'
}
</script>
